<!-- LuckyCrest Royal Splash Screen -->
<div class="splash-screen" *ngIf="isVisible" [class.is-exiting]="isExiting">
  <!-- Radial ambient backdrop & spotlight -->
  <div class="splash-ambient-bg"></div>

  <!-- Decorative Orbiting Halo Rings -->
  <div class="halo-container" aria-hidden="true">
    <div class="halo-ring ring-outer"></div>
    <div class="halo-ring ring-mid"></div>
    <div class="halo-ring ring-inner"></div>
    <div class="halo-glow"></div>
  </div>

  <!-- Floating Golden Casino Suit Ornaments -->
  <div class="floating-suits" aria-hidden="true">
    <span
      *ngFor="let suit of casinoSuits; trackBy: trackByIndex"
      class="suit-item"
      [style.left]="suit.x"
      [style.top]="suit.y"
      [style.animation-delay]="suit.delay"
      [style.font-size]="suit.size"
    >{{ suit.symbol }}</span>
  </div>

  <!-- Shimmering Gold Star Dust -->
  <div class="stardust-container" aria-hidden="true">
    <div
      *ngFor="let star of stars; trackBy: trackByIndex"
      class="gold-dust"
      [style.left]="star.left"
      [style.top]="star.top"
      [style.width.px]="star.size"
      [style.height.px]="star.size"
      [style.animation-duration.ms]="star.duration"
      [style.animation-delay.ms]="star.delay"
    ></div>
  </div>

  <!-- Center Content Presentation -->
  <div class="splash-content">
    <!-- Brand Logo with Golden Shimmer Light Beam -->
    <div class="logo-box">
      <div class="logo-aura"></div>
      <div class="logo-frame">
        <img src="/mainLogo.webp" alt="LuckyCrest" class="splash-logo" />
        <div class="logo-shimmer"></div>
      </div>
    </div>

    <!-- Luxury Tagline -->
    <div class="tagline-wrap">
      <div class="tagline-line"></div>
      <span class="tagline-text">PREMIUM SOCIAL CASINO</span>
      <div class="tagline-line"></div>
    </div>

    <!-- Casino Loading Hub -->
    <div class="loader-hub">
      <!-- Loading Status & Percentage Row -->
      <div class="loader-meta">
        <div class="status-indicator">
          <span class="status-pulse-dot"></span>
          <span class="status-text">{{ statusText }}</span>
        </div>
        <span class="status-percent">{{ progress }}%</span>
      </div>

      <!-- Liquid Gold Progress Bar -->
      <div class="progress-track">
        <div class="progress-fill" [style.width.%]="progress">
          <div class="progress-flare"></div>
        </div>
      </div>
    </div>

    <!-- Trust / Quality Badges Mini Row -->
    <div class="splash-trust-bar">
      <span class="trust-badge">
        <svg class="trust-icon" viewBox="0 0 20 20" fill="currentColor">
          <path fill-rule="evenodd" d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
        </svg>
        <span>Secure Vault</span>
      </span>
      <span class="trust-dot">•</span>
      <span class="trust-badge">
        <svg class="trust-icon" viewBox="0 0 20 20" fill="currentColor">
          <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
        </svg>
        <span>Instant Rewards</span>
      </span>
      <span class="trust-dot">•</span>
      <span class="trust-badge">
        <svg class="trust-icon" viewBox="0 0 20 20" fill="currentColor">
          <path fill-rule="evenodd" d="M10 2a1 1 0 011 1v1.323l3.954 1.582 1.599-.8a1 1 0 01.894 1.79l-1.233.616 1.738 5.42a1 1 0 01-.285 1.05A3.989 3.989 0 0115 15a3.989 3.989 0 01-2.667-1.019 1 1 0 01-.285-1.05l1.715-5.349L11 6.477V16h2a1 1 0 110 2H7a1 1 0 110-2h2V6.477L6.237 7.582l1.715 5.349a1 1 0 01-.285 1.05A3.989 3.989 0 015 15a3.989 3.989 0 01-2.667-1.019 1 1 0 01-.285-1.05l1.738-5.42-1.233-.617a1 1 0 01.894-1.788l1.599.799L9 4.323V3a1 1 0 011-1z" clip-rule="evenodd" />
        </svg>
        <span>Fair Play</span>
      </span>
    </div>
  </div>
</div>
